import { Col, Row } from "react-bootstrap";
import {
  IFullLicenceDetails,
  LicenceTypes,
} from "../../../../api/LicenceDetails";
import ApplicationDetails from "./ApplicationDetails";
import KeyDates from "./KeyDates";
import LatestDecisionDocument from "../../../../leap-components/LatestDecisionDocument";
import SiteDetails from "./SiteDetails";
import { ILicenceProfile } from "../../../../api/ILicenceProfile";
import UrbanWasteWaterSiteDetails from "../../UrbanWasteWaterSiteDetails";

interface LicenceDetailsProps {
  licence: IFullLicenceDetails;
  licenceProfile: ILicenceProfile;
}

const LicenceDetails = ({ licence, licenceProfile }: LicenceDetailsProps) => {
  const otherSiteDetails = <SiteDetails licence={licence} />;

  let siteDetails = otherSiteDetails;
  if (
    licence.siteDetails &&
    (licence.licencetype == LicenceTypes.WWDA ||
      licence.licencetype == LicenceTypes.CoA)
  ) {
    siteDetails = (
      <UrbanWasteWaterSiteDetails
        siteDetails={licenceProfile.siteDetails}
        licenceProfile={licenceProfile}
      />
    );
  }

  return (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <LatestDecisionDocument
            latestDecisionLink={licence.latestdecisionlink}
            latestDecisionType={licence.latestdecisiontype}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-4">
          <ApplicationDetails licence={licence} />
        </Col>
        <Col className="col-12 col-md-4">
          <KeyDates licence={licence} />
        </Col>
        <Col className="col-12 col-md-4">{siteDetails}</Col>
      </Row>
    </div>
  ) as JSX.Element;
};

export default LicenceDetails;
